// @flow

import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Box, IconButton, Button, Text } from 'gestalt';

type Props = {
  label: string,
  link?: string,
  onSeeAllButtonClick?: Function,
  seeAllLabel?: string,
};

const HEADER_WIDTH = 725;
const seeAllDefault = 'See all';

const SectionHeader = ({ label, link, onSeeAllButtonClick, seeAllLabel }: Props) => (
  <Box
    alignContent="end"
    alignItems="center"
    display="flex"
    justifyContent="between"
    maxWidth={HEADER_WIDTH}
    marginLeft={8}
  >
    <Box>
      <Text size="xl" weight="bold">
        {label}
      </Text>
    </Box>
    {onSeeAllButtonClick && (
      <Box flex="shrink" marginRight={-4}>
        <IconButton
          accessibilityLabel={i18n._('See all', 'Click to see all items of this type')}
          bgColor="transparent"
          icon="arrow-forward"
          iconColor="gray"
          size="lg"
          onClick={onSeeAllButtonClick}
        />
      </Box>
    )}
    {link && (
      <Box flex="shrink" marginRight={-4}>
        <NavigateLink to={link}>
          <Button color="gray" text={seeAllLabel || seeAllDefault} />
        </NavigateLink>
      </Box>
    )}
  </Box>
);

export default SectionHeader;
